import {z} from 'zod';
import {
  UpdateJobRequest,
  UpdatePartKitLotNumberRequest,
} from '../../api/generated/index.defs';
import {mapNullToUndefined, nonEmptyString} from '../../utils/zod';

export const jobPartKitLotNumberSchema = z.object({
  partKitLotNumber: mapNullToUndefined(z.string().optional()),
}) satisfies z.Schema<UpdatePartKitLotNumberRequest>;
export type JobPartKitLotNumberSchema = z.TypeOf<
  typeof jobPartKitLotNumberSchema
>;

export const jobCloseAndArchiveSchema = z.object({
  status: mapNullToUndefined(z.string().optional()),
  serialNumber: nonEmptyString(),
  levelOfServiceId: mapNullToUndefined(z.number().optional()),
  cosServiceDate: mapNullToUndefined(z.date().optional()),
}) satisfies z.Schema<UpdateJobRequest>;
export type JobCloseAndArchiveSchema = z.TypeOf<
  typeof jobCloseAndArchiveSchema
>;